var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"startseite-tour"},[_c('h4',[_vm._v(_vm._s(_vm.tourTitel))]),_c('p',[_vm._v(_vm._s(_vm.tourKurzbeschrieb))]),_c('router-link',{attrs:{"to":"/map"}},[_c('button',{attrs:{"type":"button"}},[_vm._v("Tour ansehen")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }